import ModalIndication from './ModalIndication'

export default ModalIndication
